module.exports = __webpack_public_path__ + "static/img/3.1aa2325.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/zh/3.png
// module id = SHLC
// module chunks = 0